import { defineSlotRecipe } from '@chakra-ui/react';
import { modalSlotRecipe } from '@kintsugi/ui/recipes';

/**
 * Admin dialog recipe: KDS Modal styles, plus a `full` size used by Additional
 * Details expand. KDS `modalSlotRecipe` only ships sm/md/lg/xl/table-preview;
 * without `full`, size="full" falls back to the default modal width.
 */
export const dialogSlotRecipe = defineSlotRecipe({
  slots: modalSlotRecipe.slots,
  base: modalSlotRecipe.base,
  variants: {
    ...modalSlotRecipe.variants,
    size: {
      ...(modalSlotRecipe.variants?.size ?? {}),
      full: {
        content: {
          maxW: '100dvw',
          minH: '100dvh',
          '--dialog-margin': '0',
          borderRadius: '0',
        },
      },
    },
  },
  defaultVariants: modalSlotRecipe.defaultVariants,
});
